import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { CommonService } from "app/service/common/common.service";
import { MemberService } from "app/service/member/member.service";
import { ShareService } from "app/service/share/share.service";
import { environment } from "../../environments/environment";
import { AuthService } from "../service/auth/auth.service";
import { HttpService } from "../service/http/http.service";
import { Credit, Member, Print } from "../service/member/member";
import { NotificationService } from "../service/notification/notification.service";

declare global {
  interface Window {
    ChannelIO?: IChannelIO;
    ChannelIOInitialized?: boolean;
  }
}

interface IChannelIO {
  c?: (...args: any[]) => void;
  q?: any[][]; // [string, ...any[]]
  (...args: any[]): void;
}

@Component({
  selector: "app-header-member",
  templateUrl: "./header-member.component.html",
  styleUrls: ["./header-member.component.scss"],
  providers: [ShareService, MemberService, NotificationService],
})
export class HeaderMemberComponent implements OnInit {
  public showMobileMenu = false;
  showMobileFeed: boolean = false;
  isShowPrintTip: boolean = false;
  routerScription;

  app: boolean;
  english: boolean;
  me: Member;
  credit: Credit;
  print: Print;

  constructor(
    private shareService: ShareService,
    private httpService: HttpService,
    private router: Router,
    private authService: AuthService,
    private memberService: MemberService,
    private commonService: CommonService,
    private notificationService: NotificationService
  ) {
    let userAgent = window.navigator.userAgent;
    this.app = userAgent.indexOf("hey_application") > -1;
    this.english = environment.english;

    this.shareService.awaitMe().subscribe((me) => (this.me = me));
    this.shareService
      .awaitCredit()
      .subscribe((credit) => (this.credit = credit));
    this.shareService.awaitPrint().subscribe((print) => (this.print = print));

    this.routerScription = this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      if (!this.authService.canActivate()) {
        this.router.navigateByUrl("/login");
        return;
      }

      window.scrollTo(0, 0);
    });

    window.ChannelIO('boot', {
      "pluginKey": "32c11656-0744-4091-a1da-bb6e6594ae2f",
      "member": true,
      "memberId": this.me.email,
      "memberHash": this.me.channelIOHash,
      "profile": {
        "name": this.me.name,
        "email": this.me.email,
        "mobileNumber": this.me.contact,
        "location": this.me.location.name,
      },
    });
  }

  isMobile: boolean;
  async ngOnInit() {
    this.isMobile = window.innerWidth < 768;
  }

  ngOnDestroy() {
    this.routerScription.unsubscribe();
  }

  logout() {
    if (this.app) {
      // const notificationService = this.notificationService;
      // const httpService = this.httpService;
      // FCMPlugin.getToken(function (token) {
      //   notificationService.unregist(token).subscribe(
      //     res => {},
      //     err => {},
      //     () => httpService.logout()
      //   );
      // });
      this.httpService.logout();
    } else {
      this.httpService.logout();
    }
    this.router.navigate(["/", "login"]);
  }

  openMobileMenu() {
    this.showMobileMenu = true;
  }

  closeMobileMenu() {
    this.showMobileMenu = false;
  }

  onMenuOpen(): boolean {
    return this.showMobileMenu || this.showMobileFeed;
  }

  hasManager() {
    return this.authService.hasManager();
  }

  // 모두의 주차장 (서울숲만)
  isSeoulsoop() {
    if (this.me) {
      return this.me.location.key === "seoulsoop";
    }

    return false;
  }

  async handleModu(evt) {
    evt.preventDefault();
    const policy = await this.memberService.getPolicy();

    if (!policy.thirdParty) {
      alert(
        "개인정보 제3자 제공에 동의한 멤버에 한하여 본 서비스 이용이 가능합니다."
      );
      this.commonService.openThirdPartyModal();
    } else {
      try {
        const isApp =
          window.navigator.userAgent.indexOf("hey_application") > -1;
        let {
          authorizationUrl,
        } = await this.memberService.getModuURL().toPromise();

        if (isApp) {
          authorizationUrl += `&callbackUrl=${location.href}`;
          location.href = authorizationUrl;
        } else {
          window.open(authorizationUrl, "_blank").focus();
        }
      } catch (error) {
        alert("관리자에게 문의 바랍니다.");
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/header-member/header-member.component.ts